





















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { formatNum } from '../../render';
import { IDpgIncrementList } from '@/store/home/stats/types';
import DataTable from '../../common/DataTable.vue';

const Stats = namespace('home/stats');

@Component({
  components: { DataTable },
})
export default class DpgIncrementTable extends Vue {
  @Stats.State('dpgIncrementList') public list!: IDpgIncrementList;

  public dpgHeaders = [
    { text: '组织名称', value: 'orgName' },
    { text: '专案组数量', value: 'dpgTotalCount' },
  ];
  public roomHeaders = [
    { text: '组织名称', value: 'orgName' },
    { text: '样板间数量', value: 'blankRoomTotalCount' },
  ];

  // 专案组
  public get dpgItems() {
    return this.list.data.filter((item) => item.type === 1).map((item) => {
      const dpgTotalCount = formatNum(item.dpgTotalCount);
      return { orgName: item.orgName, dpgTotalCount };
    });
  }

  // 样板间
  public get roomItems() {
    return this.list.data.filter((item) => item.type === 2).map((item) => {
      const blankRoomTotalCount = formatNum(item.blankRoomTotalCount);
      return { orgName: item.orgName, blankRoomTotalCount };
    });
  }
}
